import { useState } from "react";
let memoizedScrollbarWidth = null;
export const getScrollbarWidth = () => {
    if (memoizedScrollbarWidth !== null)
        return memoizedScrollbarWidth;
    const probe = document.createElement("div");
    probe.style.width = "100px";
    probe.style.height = "100px";
    probe.style.overflow = "scroll";
    probe.style.position = "absolute";
    probe.style.top = "-9999px";
    document.body.appendChild(probe);
    memoizedScrollbarWidth = probe.offsetWidth - probe.clientWidth;
    document.body.removeChild(probe);
    return memoizedScrollbarWidth;
};
const useHasOverlayScrollbars = () => {
    const [hasOverlayScrollbars] = useState(() => getScrollbarWidth() === 0);
    return hasOverlayScrollbars;
};
export default useHasOverlayScrollbars;
//# sourceMappingURL=useHasOverlayScrollbars.js.map